import React, { FC } from "react"
import xss from "xss"

import { ImageType } from "@srcTypes"

import Avatar, { AVATAR_SIZES } from "@components/Avatar/Avatar"
import AnchorLink from "@components/AnchorLink/AnchorLink"

import "./AuthorByline.scss"

type AuthorBylineProps = {
  bio: string,
  href: string,
  image?: ImageType | null,
  name: string,
}

const AuthorByline: FC<AuthorBylineProps> = ({
  bio,
  href,
  image,
  name,
}) => (
  <div className="AuthorByline">
    {image && (
      <AnchorLink href={href}>
        <Avatar
          name={name}
          image={image}
          size={AVATAR_SIZES.XL}
        />
      </AnchorLink>
    )}
    <div>
      <h5 className="margin-bottom--base-0-75 font-weight--semibold color--text-dark">
        <AnchorLink href={href}>{name}</AnchorLink>
      </h5>
      <div dangerouslySetInnerHTML={{ __html: xss(bio) }} />
    </div>
  </div>
)

export default AuthorByline
